import React from 'react';
import { observer } from 'mobx-react';
import styled from 'styled-components';

import { Field } from 'libs/forms/views/field';
import { Validation } from 'libs/forms/views/validation';
import { InputWrapper, WrappedInput } from 'libs/forms/styles';
import { PasswordFieldStore } from 'libs/forms/fieldStores';
/*
      options: fieldConf.options || {},
*/

import i18next from 'i18next';

@observer
export class PasswordField extends Field {
  static defaultStore = PasswordFieldStore;
  toggleText = e => {
    const { fieldStore } = this.props;
    e.preventDefault();
    fieldStore.ToggleShow();
  };

  componentDidMount() {
    if (this.props.fieldStore.autoFocus) {
      this._input.focus();
    }
  }

  render() {
    const { fieldStore, noValidation, responsive, editComponent } = this.props;
    const Tag = editComponent || InputWrapper;
    return (
      <Tag focussed={fieldStore.isFocussed} responsive={responsive}>
        <WrappedInput
          type={fieldStore.show ? 'text' : 'password'}
          className='inputNoBorder'
          id={this.inputId}
          ref={input => {
            this._input = input;
          }}
          value={fieldStore.value}
          placeholder={
            fieldStore.conf.placeholder &&
            i18next.t(fieldStore.conf.placeholder)
          }
          onFocus={this.onFocus}
          onBlur={this.onBlur}
          onChange={this.updateValue}
          posting={fieldStore.formStore.posting}
          responsive={responsive}
          autocomplete='new-password'
        />
        <Text
          displayNone={!fieldStore.isFocussed}
          onMouseDown={this.toggleText}
        >
          {fieldStore.show ? 'HIDE' : 'SHOW'}
        </Text>
        {noValidation ? (
          ''
        ) : (
          <Validation
            fieldStore={fieldStore}
            handleClick={this.focusAfterDelete}
          />
        )}
      </Tag>
    );
  }
}

const Text = styled.div`
  font-weight: 600;
  font-size: 11px;
  color: rgba(0, 0, 0, 0.25);
  display: inline-block;
  display: ${props => (props.displayNone ? 'none' : 'block')};
  border: none;
  background-color: ${props => props.theme.color.wfWhite};
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 10px;
  &:hover {
    cursor: pointer;
    color: rgba(0, 0, 0, 0.4);
  }
`;
